var _defs, _path, _path2, _text, _path3, _path4, _text2, _path5, _path6, _text3, _path7, _path8, _text4, _path9, _path10, _text5, _path11, _path12, _text6, _text7, _text8, _text9, _path13, _path14, _text10, _text11, _path15, _path16, _text12, _text13, _path17, _path18, _text14, _text15, _text16, _path19, _path20, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _path21, _text24, _text25, _path22, _path23, _text26, _path24, _text27, _text28, _path25, _path26, _text29, _text30, _text31, _text32, _path27, _text33, _text34, _path28, _path29, _text35, _text36, _path30, _text37, _text38, _path31, _path32, _text39, _text40, _text41, _text42, _text43, _path33, _text44, _text45, _path34, _path35, _text46, _text47, _text48, _text49, _path36, _text50, _text51, _path37, _path38, _text52, _path39, _text53, _text54, _path40, _path41, _text55, _text56, _text57, _path42, _text58, _text59, _path43, _path44, _text60, _text61, _text62, _path45, _text63, _text64, _path46, _path47, _text65, _text66, _text67, _text68, _text69, _path48, _text70, _text71, _path49, _path50, _text72, _path51, _text73, _text74, _path52, _path53, _text75, _text76, _path54, _text77, _text78, _path55, _path56, _text79, _text80, _path57, _text81, _text82, _path58, _path59, _text83, _text84, _path60, _path61, _text85, _text86, _path62, _path63, _text87, _path64, _path65, _text88, _text89, _path66, _path67, _text90, _text91, _path68, _path69, _text92, _text93, _path70, _path71, _text94, _text95, _path72, _path73, _text96, _text97, _text98, _path74, _path75, _text99, _path76, _path77, _text100, _path78, _path79, _text101, _text102, _path80, _text103, _text104, _path81, _path82, _text105, _text106, _path83, _text107, _text108, _path84, _path85, _text109, _text110, _text111, _path86, _text112, _text113, _path87, _path88, _text114, _path89, _text115, _text116, _path90, _path91, _text117, _text118, _text119, _text120, _text121, _path92, _path93, _text122, _text123, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStructuRu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7610.8 5562.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 83px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-3 {\n        font-family: Cambria-Bold, Cambria;\n        font-weight: 700;\n      }\n\n      .cls-5 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-6 {\n        fill: #329cc6;\n      }\n\n      .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16 {\n        fill-rule: evenodd;\n      }\n\n      .cls-17 {\n        letter-spacing: 0em;\n      }\n\n      .cls-18 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-19 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        fill: #002060;\n      }\n\n      .cls-8 {\n        fill: #697fd7;\n      }\n\n      .cls-9 {\n        fill: #7030a0;\n      }\n\n      .cls-10 {\n        fill: #d86ecc;\n      }\n\n      .cls-11 {\n        fill: #fff;\n        stroke: #fff;\n      }\n\n      .cls-11, .cls-20, .cls-21 {\n        stroke-dasharray: 27.5 20.62;\n        stroke-miterlimit: 8;\n        stroke-width: 6.88px;\n      }\n\n      .cls-22 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-12, .cls-23 {\n        fill: #00b0f0;\n      }\n\n      .cls-24 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-2 {\n        font-family: Cambria, Cambria;\n      }\n\n      .cls-2, .cls-3 {\n        font-size: 73px;\n      }\n\n      .cls-13 {\n        fill: #145fcb;\n      }\n\n      .cls-20 {\n        stroke: #145fcb;\n      }\n\n      .cls-20, .cls-21 {\n        fill: none;\n      }\n\n      .cls-14 {\n        fill: #8ed973;\n      }\n\n      .cls-15 {\n        fill: #f2f4f9;\n      }\n\n      .cls-25 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-26 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-16 {\n        fill: #61cbf4;\n      }\n\n      .cls-27 {\n        letter-spacing: .01em;\n      }\n\n      .cls-28 {\n        letter-spacing: 0em;\n      }\n\n      .cls-29 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-30 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-31 {\n        letter-spacing: -.1em;\n      }\n\n      .cls-32 {\n        letter-spacing: .02em;\n      }\n\n      .cls-33 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-34 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-21 {\n        stroke: #002060;\n      }\n\n      .cls-35 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-36 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-37 {\n        letter-spacing: -.1em;\n      }\n\n      .cls-38 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-39 {\n        letter-spacing: 0em;\n      }\n\n      .cls-4 {\n        fill: #747474;\n        font-family: Bahnschrift, Bahnschrift;\n        font-size: 146px;\n        font-variation-settings: 'wght' 400, 'wdth' 100;\n      }\n\n      .cls-40 {\n        letter-spacing: -.01em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M975.75,70.51c0-37.04,30.03-67.07,67.07-67.07h1112.86c37.04,0,67.07,30.03,67.07,67.07v221.86c0,37.04-30.03,67.07-67.07,67.07h-1112.86c-37.04,0-67.07-30.03-67.07-67.07V70.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1042.25,2.94h1113c23.13,0,43.51,12,55.55,30.26l1.45,2.74H985.25l1.45-2.74c12.04-18.26,32.42-30.26,55.55-30.26Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(1259.53 211.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 0,
    y: 0
  }, "\u0421"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.35,
    y: 0
  }, "\u043E\u0432\u0435\u0442 \u0443\u0447\u0440\u0435\u0434\u0438"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 470.69,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 507.33,
    y: 0
  }, "\u0435\u043B\u0435\u0439"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2446.75,70.51c0-37.04,30.03-67.07,67.07-67.07h1112.86c37.04,0,67.07,30.03,67.07,67.07v221.86c0,37.04-30.03,67.07-67.07,67.07h-1112.86c-37.04,0-67.07-30.03-67.07-67.07V70.51Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2513.25,2.94h1113c23.13,0,43.51,12,55.55,30.26l1.45,2.74h-1227l1.45-2.74c12.04-18.26,32.42-30.26,55.55-30.26Z"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(2626.15 211.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041F\u0440\u0435\u0437\u0438\u0434\u0435\u043D\u0442 \u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0438"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 729.82,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 766.46,
    y: 0
  }, "\u0435\u0442\u0430"))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2446.75,585.85c0-46.62,37.79-84.41,84.41-84.41h1078.18c46.62,0,84.41,37.79,84.41,84.41v279.18c0,46.62-37.79,84.41-84.41,84.41h-1078.18c-46.62,0-84.41-37.79-84.41-84.41v-279.18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2513.25,500.94h1113c23.13,0,43.51,14.55,55.55,36.68l1.45,3.32h-1227l1.45-3.32c12.04-22.13,32.42-36.68,55.55-36.68Z"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(2930.63 707.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 0,
    y: 0
  }, "\u0420"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.88,
    y: 0
  }, "\u0435\u043A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 142.01,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 183.67,
    y: 0
  }, "\u043E\u0440"))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M975.75,614.51c0-37.04,30.03-67.07,67.07-67.07h1112.86c37.04,0,67.07,30.03,67.07,67.07v221.86c0,37.04-30.03,67.07-67.07,67.07h-1112.86c-37.04,0-67.07-30.03-67.07-67.07v-221.86Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1042.25,546.94h1113c23.13,0,43.51,11.64,55.55,29.35l1.45,2.65H985.25l1.45-2.65c12.04-17.71,32.42-29.35,55.55-29.35Z"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(1185.34 755.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 0,
    y: 0
  }, "\u0423"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.89,
    y: 0
  }, "\u043D\u0438\u0432\u0435\u0440\u0441\u0438"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 332.31,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 368.96,
    y: 0
  }, "\u0435"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 407.7,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 444.34,
    y: 0
  }, "\u0441\u043A\u0438\u0439 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 629.84,
    y: 0
  }, "\u0441"), /*#__PURE__*/React.createElement("tspan", {
    x: 663.63,
    y: 0
  }, "\u043E\u0432\u0435\u0442"))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3927.75,614.51c0-37.04,30.03-67.07,67.07-67.07h1112.86c37.04,0,67.07,30.03,67.07,67.07v221.86c0,37.04-30.03,67.07-67.07,67.07h-1112.86c-37.04,0-67.07-30.03-67.07-67.07v-221.86Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3994.25,546.94h1113c23.13,0,43.51,11.64,55.55,29.35l1.45,2.65h-1227l1.45-2.65c12.04-17.71,32.42-29.35,55.55-29.35Z"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(4230.41 755.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 0,
    y: 0
  }, "\u0421"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.35,
    y: 0
  }, "\u043E\u0432\u0435\u0442\u043D\u0438\u043A \u0440\u0435\u043A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 476.28,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 512.92,
    y: 0
  }, "\u043E\u0440\u0430"))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M272.75,1390.96c0-52.75,42.77-95.52,95.52-95.52h1055.95c52.76,0,95.52,42.77,95.52,95.52v315.96c0,52.75-42.77,95.52-95.52,95.52H368.27c-52.76,0-95.52-42.77-95.52-95.52v-315.96Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.25,1294.94h1113.01c23.12,0,43.51,16.73,55.55,42.19l1.45,3.81H282.25l1.45-3.81c12.04-25.46,32.43-42.19,55.55-42.19Z"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(421.54 1500.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041F\u0435\u0440\u0432\u044B\u0439 \u043F\u0440\u043E\u0440\u0435\u043A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 513.71,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 551.1,
    y: 0
  }, "\u043E\u0440 \u043F\u043E \u0434\u0435\u043B\u0430\u043C "))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(540.71 1588.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u043C\u043E\u043B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 128.68,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    x: 165.68,
    y: 0
  }, "\u0434\u0435\u0436\u0438 \u0438 \u0434\u0443"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 489.93,
    y: 0
  }, "\u0445"), /*#__PURE__*/React.createElement("tspan", {
    x: 523.62,
    y: 0
  }, "\u043E\u0432\u043D\u043E"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1225.99 1588.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(467.26 1676.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u043F\u0440\u043E\u0441\u0432\u0435\u0442\u0438"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 307.08,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 344.47,
    y: 0
  }, "\u0435\u043B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 420.89,
    y: 0
  }, "\u044C"), /*#__PURE__*/React.createElement("tspan", {
    x: 458.5,
    y: 0
  }, "\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 490.68,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 529.46,
    y: 0
  }, "\u043E\u0439 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 627.34,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 668.01,
    y: 0
  }, "\u0430\u0431"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 743.15,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 780.86,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 818.26,
    y: 0
  }, "\u0435"))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1707.75,1390.96c0-52.75,42.77-95.52,95.52-95.52h1054.96c52.75,0,95.52,42.77,95.52,95.52v315.96c0,52.75-42.77,95.52-95.52,95.52h-1054.96c-52.76,0-95.52-42.77-95.52-95.52v-315.96Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1774.2,1294.94h1112.1c23.1,0,43.47,16.73,55.5,42.19l1.45,3.81h-1226l1.45-3.81c12.03-25.46,32.4-42.19,55.5-42.19Z"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1954.66 1554.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041F\u0440\u043E\u0440\u0435\u043A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 244.2,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 281.59,
    y: 0
  }, "\u043E\u0440 \u043F\u043E \u0443\u0447\u0435\u0431\u043D\u043E\u0439 "))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2216.67 1642.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 0,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.67,
    y: 0
  }, "\u0430\u0431"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 115.81,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 153.52,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 190.91,
    y: 0
  }, "\u0435"))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3157.75,1390.96c0-52.75,42.77-95.52,95.52-95.52h1055.96c52.75,0,95.52,42.77,95.52,95.52v315.96c0,52.75-42.77,95.52-95.52,95.52h-1055.96c-52.75,0-95.52-42.77-95.52-95.52v-315.96Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3224.25,1294.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3371.9 1542.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041F\u0440\u043E\u0440\u0435\u043A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 244.2,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 281.59,
    y: 0
  }, "\u043E\u0440 \u043F\u043E \u043D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 516.2,
    y: 0
  }, "\u0430"), /*#__PURE__*/React.createElement("tspan", {
    x: 550.39,
    y: 0
  }, "\u0443\u0447\u043D\u043E\u0439 "))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3389.13 1630.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 0,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.67,
    y: 0
  }, "\u0430\u0431"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 115.81,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 153.52,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 190.91,
    y: 0
  }, "\u0435 \u0438 \u0438\u043D\u043D\u043E\u0432\u0430\u0446\u0438\u044F\u043C"))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M4607.75,1391.15c0-52.86,42.85-95.71,95.71-95.71h1055.58c52.86,0,95.71,42.85,95.71,95.71v316.58c0,52.86-42.85,95.71-95.71,95.71h-1055.58c-52.86,0-95.71-42.85-95.71-95.71v-316.58Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M4674.25,1294.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4798.87 1541.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041F\u0440\u043E\u0440\u0435\u043A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 244.2,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 281.59,
    y: 0
  }, "\u043E\u0440 \u043F\u043E \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u043E"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(5637.69 1541.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4734.2 1629.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u044D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.33,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.11,
    y: 0
  }, "\u043E\u043D\u043E\u043C\u0438\u0447\u0435\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 392.3,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 431.08,
    y: 0
  }, "\u043E\u0439 \u0434\u0435\u044F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 644.06,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 681.45,
    y: 0
  }, "\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438"))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M272.75,1998.66c0-68.05,55.17-123.22,123.22-123.22h1000.56c68.05,0,123.22,55.17,123.22,123.22v407.56c0,68.05-55.17,123.22-123.22,123.22H395.97c-68.05,0-123.22-55.17-123.22-123.22v-407.56Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.25,1874.94h1113.01c23.12,0,43.51,16.37,55.55,41.27l1.45,3.73H282.25l1.45-3.73c12.04-24.9,32.43-41.27,55.55-41.27Z"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(430.57 2218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 47.69,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 81.8,
    y: 0
  }, "\u0434\u0435\u043B "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 215.04,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 255.71,
    y: 0
  }, "\u0430\u0431"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 330.85,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    x: 368.56,
    y: 0
  }, "\u0442\u044B \u0441 \u043C\u043E\u043B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 653.51,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    x: 690.51,
    y: 0
  }, "\u0434\u0435\u0436\u044C\u044E, "))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(440.95 2306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0434\u0443"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 77.53,
    y: 0
  }, "\u0445"), /*#__PURE__*/React.createElement("tspan", {
    x: 111.21,
    y: 0
  }, "\u043E\u0432\u043D\u043E"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(712.06 2306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(736.69 2306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u043F\u0440\u043E\u0441\u0432\u0435\u0442\u0438"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 307.08,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 344.47,
    y: 0
  }, "\u0435\u043B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 420.89,
    y: 0
  }, "\u044C"), /*#__PURE__*/React.createElement("tspan", {
    x: 458.5,
    y: 0
  }, "\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 490.68,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 529.46,
    y: 0
  }, "\u043E\u0439 "))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(339.04 2394.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0434\u0435\u044F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 115.1,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 152.49,
    y: 0
  }, "\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1427.65 2394.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(584.5 2482.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0440\u0435\u0441\u0443\u0440\u0441\u043D\u043E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 299.7,
    y: 0
  }, "\u0433"), /*#__PURE__*/React.createElement("tspan", {
    x: 332.39,
    y: 0
  }, "\u043E \u0446\u0435\u043D\u0442"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 544.72,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 585.39,
    y: 0
  }, "\u0430"))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M814.25,1974.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(861.73 2086.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(936.78 2086.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M272.75,2696.06c0-50.05,40.58-90.63,90.63-90.63h1065.75c50.05,0,90.63,40.57,90.63,90.63v299.75c0,50.05-40.58,90.63-90.63,90.63H363.38c-50.05,0-90.63-40.58-90.63-90.63v-299.75Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.25,2604.94h1113.01c23.12,0,43.51,16.73,55.55,42.19l1.45,3.81H282.25l1.45-3.81c12.04-25.45,32.43-42.19,55.55-42.19Z"
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(740.35 2949.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041F\u0441\u0438"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 124.47,
    y: 0
  }, "\u0445"), /*#__PURE__*/React.createElement("tspan", {
    x: 158.15,
    y: 0
  }, "\u043E\u043B\u043E\u0433"))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M814.25,2705.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(875.04 2817.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(923.73 2817.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1707.75,1980.01c0-57.75,46.82-104.57,104.57-104.57h1036.86c57.75,0,104.57,46.82,104.57,104.57v345.86c0,57.75-46.82,104.57-104.57,104.57h-1036.86c-57.75,0-104.57-46.82-104.57-104.57v-345.86Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1774.2,1874.94h1112.1c23.1,0,43.47,16.37,55.5,41.27l1.45,3.73h-1226l1.45-3.73c12.03-24.9,32.4-41.27,55.5-41.27Z"
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1966.18 2218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0423\u0447\u0435\u0431\u043D\u043E"))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2206.23 2218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2230.87 2218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u043C\u0435"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 84.73,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 122.12,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    x: 159.12,
    y: 0
  }, "\u0434\u0438\u0447\u0435\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 349.46,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 388.24,
    y: 0
  }, "\u043E\u0435 "))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2133.7 2306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0443\u043F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 78.17,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 118.84,
    y: 0
  }, "\u0430\u0432\u043B\u0435\u043D\u0438\u0435"))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2249.25,1974.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(2296.31 2086.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8"))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(2378.23 2086.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1707.75,2606.79c0-61.5,49.85-111.35,111.35-111.35h1023.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1023.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1774.2,2494.94h1112.1c23.1,0,43.47,16.73,55.5,42.18l1.45,3.82h-1226l1.45-3.82c12.03-25.45,32.4-42.18,55.5-42.18Z"
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1996.13 2839.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 47.69,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 81.8,
    y: 0
  }, "\u0434\u0435\u043B \u043C\u0430\u0440"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 340.41,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 379.19,
    y: 0
  }, "\u0435\u0442\u0438\u043D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 538.16,
    y: 0
  }, "\u0433"), /*#__PURE__*/React.createElement("tspan", {
    x: 570.85,
    y: 0
  }, "\u0430 \u0438 "))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1935.93 2927.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 32.19,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 70.33,
    y: 0
  }, "\u0443"), /*#__PURE__*/React.createElement("tspan", {
    x: 103.16,
    y: 0
  }, "\u0434\u0435\u043D\u0447\u0435\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 329.03,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 367.82,
    y: 0
  }, "\u043E\u0439 \u043F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 507.08,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 547.75,
    y: 0
  }, "\u0430\u043A\u0442\u0438\u043A\u0438"))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2249.25,2595.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(2296.31 2707.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(2379.38 2707.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3157.75,1998.66c0-68.05,55.17-123.22,123.22-123.22h1000.56c68.05,0,123.22,55.17,123.22,123.22v407.56c0,68.05-55.17,123.22-123.22,123.22h-1000.56c-68.05,0-123.22-55.17-123.22-123.22v-407.56Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3224.25,1874.94h1113c23.13,0,43.51,16.37,55.55,41.27l1.45,3.73h-1227l1.45-3.73c12.04-24.9,32.42-41.27,55.55-41.27Z"
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3279.16 2218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 47.69,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 81.8,
    y: 0
  }, "\u0434\u0435\u043B \u043D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 258.03,
    y: 0
  }, "\u0430"), /*#__PURE__*/React.createElement("tspan", {
    x: 292.21,
    y: 0
  }, "\u0443\u0447\u043D\u044B\u0445 \u0438\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0439, "))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3246.81 2306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0438\u043D\u043D\u043E\u0432\u0430\u0446\u0438\u0439, \u043F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 441.74,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    x: 478.74,
    y: 0
  }, "\u0434"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 519.48,
    y: 0
  }, "\u0433"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 552.17,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 589.88,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 627.27,
    y: 0
  }, "\u043E\u0432\u043A\u0438 \u043D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 845.74,
    y: 0
  }, "\u0430"), /*#__PURE__*/React.createElement("tspan", {
    x: 879.92,
    y: 0
  }, "\u0443\u0447\u043D\u043E"))), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4289.4 2306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3206.52 2394.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u043F\u0435\u0434\u0430"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 153.38,
    y: 0
  }, "\u0433"), /*#__PURE__*/React.createElement("tspan", {
    x: 186.06,
    y: 0
  }, "\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043A\u0430\u0434\u0440\u043E\u0432 \u0438 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 849.41,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 890.08,
    y: 0
  }, "\u0430\u0431"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 965.22,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    x: 1002.93,
    y: 0
  }, "\u0442\u044B \u0441 "))), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3328.87 2482.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0442\u0430\u043B\u0430\u043D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 192.41,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 226.16,
    y: 0
  }, "\u043B\u0438\u0432\u044B\u043C\u0438 \u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 543.26,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 581.4,
    y: 0
  }, "\u0443"), /*#__PURE__*/React.createElement("tspan", {
    x: 614.23,
    y: 0
  }, "\u0434\u0435\u043D\u0442\u0430\u043C\u0438"))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M3699.25,1974.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(3746.48 2086.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(3829.56 2086.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3157.75,2696.85c0-68.16,55.25-123.41,123.41-123.41h1000.18c68.16,0,123.41,55.25,123.41,123.41v408.18c0,68.16-55.25,123.41-123.41,123.41h-1000.18c-68.16,0-123.41-55.25-123.41-123.41v-408.18Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3224.25,2572.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3402.42 2889.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 0,
    y: 0
  }, "\u0423"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.49,
    y: 0
  }, "\u043F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 80.88,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 121.55,
    y: 0
  }, "\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0446\u0438\u0444\u0440\u043E\u0432\u044B\u0445 "))), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3253.97 2977.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u043E\u0431"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 78.24,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 118.91,
    y: 0
  }, "\u0430\u0437\u043E\u0432\u0430"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 300.55,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 337.95,
    y: 0
  }, "\u0435\u043B\u044C\u043D\u044B\u0445 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 600.86,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 638.25,
    y: 0
  }, "\u0435"), /*#__PURE__*/React.createElement("tspan", {
    x: 672.97,
    y: 0
  }, "\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0439 \u0438 "))), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3422.84 3065.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 0,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.67,
    y: 0
  }, "\u0430\u0431"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 115.81,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    x: 153.52,
    y: 0
  }, "\u0442\u044B \u0441 \u043C\u0435\u0441\u0442\u043D\u044B\u043C\u0438 \u0438 "))), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3267.63 3153.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u043C\u0435"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 84.73,
    y: 0
  }, "\u0436"), /*#__PURE__*/React.createElement("tspan", {
    x: 138.02,
    y: 0
  }, "\u0434\u0443\u043D\u0430\u0440"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 334.77,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    x: 371.77,
    y: 0
  }, "\u0434\u043D\u044B\u043C\u0438 \u0440\u0435\u0439\u0442\u0438\u043D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 860.99,
    y: 0
  }, "\u0433"), /*#__PURE__*/React.createElement("tspan", {
    x: 893.68,
    y: 0
  }, "\u0430\u043C\u0438"))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M3699.25,2673.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(3746.48 2785.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(3821.54 2785.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M4620.75,2606.79c0-61.5,49.85-111.35,111.35-111.35h1024.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1024.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M4687.25,2494.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4944.95 2839.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 0,
    y: 0
  }, "\u0413"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.4,
    y: 0
  }, "\u043B\u0430\u0432\u043D\u044B\u0439 \u0438\u043D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 388.81,
    y: 0
  }, "\u0436"), /*#__PURE__*/React.createElement("tspan", {
    x: 440.28,
    y: 0
  }, "\u0435\u043D\u0435\u0440"))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M5162.25,2595.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5218.69 2707.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5267.39 2707.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M4620.75,1957.79c0-61.5,49.85-111.35,111.35-111.35h1024.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1024.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M4687.25,1845.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4842.78 2213.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0411\u0443\u0445"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 115.81,
    y: 0
  }, "\u0433"), /*#__PURE__*/React.createElement("tspan", {
    x: 148.5,
    y: 0
  }, "\u0430\u043B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 224.95,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 262.34,
    y: 0
  }, "\u0435\u0440\u0438\u044F \u0438 \u043F\u043B\u0430\u043D\u043E\u0432\u043E"))), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(5619.79 2213.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4928.9 2301.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u0439 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 437.54,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 475.25,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 509.36,
    y: 0
  }, "\u0434\u0435\u043B"))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M5162.25,1946.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5209.67 2058.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5292.74 2058.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M4620.75,3242.79c0-61.5,49.85-111.35,111.35-111.35h1024.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1024.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M4687.25,3130.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4910.76 3475.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 47.69,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 81.8,
    y: 0
  }, "\u0434\u0435\u043B "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 215.04,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 252.43,
    y: 0
  }, "\u0435"), /*#__PURE__*/React.createElement("tspan", {
    x: 287.15,
    y: 0
  }, "\u0445\u043D\u0438\u0447\u0435\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 515.03,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 553.81,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 592.55,
    y: 0
  }, "\u0433"), /*#__PURE__*/React.createElement("tspan", {
    x: 625.24,
    y: 0
  }, "\u043E "))), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4971.47 3563.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F \u0438 "))), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4754.24 3651.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 0,
    y: 0
  }, "\u0445"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.68,
    y: 0
  }, "\u043E\u0437\u044F\u0439\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0439 \u0434\u0435\u044F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 629.91,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 667.3,
    y: 0
  }, "\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438"))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M5162.25,3230.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5171.2 3342.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "22"))), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5321.87 3342.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M4620.75,3868.79c0-61.5,49.85-111.35,111.35-111.35h1024.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1024.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M4687.25,3756.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4884.8 4101.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041F\u0440\u0435\u0441\u0441"))), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(5074.43 4101.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(5099.07 4101.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0441\u043B\u0443\u0436\u0431\u0430 \u0438 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 312.25,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 349.96,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 384.07,
    y: 0
  }, "\u0434\u0435\u043B "))), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4829.41 4189.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 0,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.78,
    y: 0
  }, "\u043E\u043E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 116.27,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 155.12,
    y: 0
  }, "\u0434\u0438\u043D\u0430\u0446\u0438\u0438 \u043F\u0440\u0438\u0435\u043C\u043D\u043E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 752.85,
    y: 0
  }, "\u0433"), /*#__PURE__*/React.createElement("tspan", {
    x: 785.53,
    y: 0
  }, "\u043E "))), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(5094.07 4277.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430"))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M5162.25,3857.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v123c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-123Z"
  })), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5209.67 3968.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9"))), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5284.72 3968.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M272.75,3514.06c0-50.05,40.58-90.63,90.63-90.63h1065.75c50.05,0,90.63,40.57,90.63,90.63v299.74c0,50.06-40.58,90.63-90.63,90.63H363.38c-50.05,0-90.63-40.57-90.63-90.63v-299.74Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M339.25,3422.94h1113.01c23.12,0,43.51,16.73,55.55,42.18l1.45,3.82H282.25l1.45-3.82c12.04-25.45,32.43-42.18,55.55-42.18Z"
  })), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(442.96 3767.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041F\u0435\u0434\u0430"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 161.22,
    y: 0
  }, "\u0433"), /*#__PURE__*/React.createElement("tspan", {
    x: 193.91,
    y: 0
  }, "\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0439 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 556.48,
    y: 0
  }, "\u0444"), /*#__PURE__*/React.createElement("tspan", {
    x: 606.56,
    y: 0
  }, "\u0430\u043A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 681.63,
    y: 0
  }, "\u0443"), /*#__PURE__*/React.createElement("tspan", {
    x: 715.56,
    y: 0
  }, "\u043B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 756.38,
    y: 0
  }, "\u044C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 791.06,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 828.45,
    y: 0
  }, "\u0435\u0442"))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M814.25,3523.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(861.73 3635.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(936.78 3635.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1717.75,3514.06c0-50.05,40.57-90.62,90.62-90.62h1064.74c50.06,0,90.63,40.57,90.63,90.62v299.74c0,50.06-40.57,90.63-90.63,90.63h-1064.74c-50.05,0-90.62-40.57-90.62-90.63v-299.74Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1784.2,3422.94h1112.1c23.1,0,43.47,16.73,55.5,42.18l1.45,3.82h-1226l1.45-3.82c12.03-25.45,32.4-42.18,55.5-42.18Z"
  })), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1938.9 3767.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 0,
    y: 0
  }, "\u0424"), /*#__PURE__*/React.createElement("tspan", {
    x: 56.21,
    y: 0
  }, "\u0430\u043A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 131.28,
    y: 0
  }, "\u0443"), /*#__PURE__*/React.createElement("tspan", {
    x: 165.21,
    y: 0
  }, "\u043B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 206.03,
    y: 0
  }, "\u044C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 240.71,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 278.1,
    y: 0
  }, "\u0435\u0442 \u0444\u0438\u043B\u043E\u043B\u043E\u0433\u0438\u0438 \u0438 "))), _text76 || (_text76 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2200.41 3855.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0438\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 75.25,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 112.64,
    y: 0
  }, "\u043E\u0440\u0438\u0438"))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2259.25,3523.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text77 || (_text77 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(2305.82 3635.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text78 || (_text78 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(2380.87 3635.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3157.75,3514.06c0-50.05,40.57-90.63,90.63-90.63h1065.74c50.06,0,90.63,40.57,90.63,90.63v299.74c0,50.06-40.57,90.63-90.63,90.63h-1065.74c-50.06,0-90.63-40.57-90.63-90.63v-299.74Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3224.25,3422.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text79 || (_text79 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3362.44 3767.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 0,
    y: 0
  }, "\u0424"), /*#__PURE__*/React.createElement("tspan", {
    x: 56.21,
    y: 0
  }, "\u0430\u043A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 131.28,
    y: 0
  }, "\u0443"), /*#__PURE__*/React.createElement("tspan", {
    x: 165.21,
    y: 0
  }, "\u043B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 206.03,
    y: 0
  }, "\u044C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 240.71,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 278.1,
    y: 0
  }, "\u0435\u0442 \u043C\u0430"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 451.87,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 489.26,
    y: 0
  }, "\u0435\u043C\u0430\u0442\u0438\u043A\u0438 \u0438 "))), _text80 || (_text80 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3595.41 3855.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u044D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.33,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.11,
    y: 0
  }, "\u043E\u043D\u043E\u043C\u0438\u043A\u0438"))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M3699.25,3523.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text81 || (_text81 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(3746.49 3635.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text82 || (_text82 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(3821.54 3635.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M272.75,4041.87c0-39.45,31.98-71.43,71.43-71.43h1104.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43H344.18c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M339.25,3969.94h1113.01c23.12,0,43.51,16.73,55.55,42.19l1.45,3.81H282.25l1.45-3.81c12.04-25.46,32.43-42.19,55.55-42.19Z"
  })), _text83 || (_text83 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(465.06 4136.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041A\u0430\u0444\u0435\u0434"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 209.45,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 250.12,
    y: 0
  }, "\u0430 \u043F\u0435\u0434\u0430"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 455.22,
    y: 0
  }, "\u0433"), /*#__PURE__*/React.createElement("tspan", {
    x: 487.9,
    y: 0
  }, "\u043E\u0433\u0438\u0447\u0435\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 708.86,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 747.64,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 786.39,
    y: 0
  }, "\u0433"), /*#__PURE__*/React.createElement("tspan", {
    x: 819.08,
    y: 0
  }, "\u043E "))), _text84 || (_text84 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(448.7 4224.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u043E\u0431"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 78.24,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 118.91,
    y: 0
  }, "\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0438 \u043F\u0441\u0438"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 617.19,
    y: 0
  }, "\u0445"), /*#__PURE__*/React.createElement("tspan", {
    x: 650.87,
    y: 0
  }, "\u043E\u043B\u043E\u0433\u0438\u0438"))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M272.75,4419.87c0-39.45,31.98-71.43,71.43-71.43h1104.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43H344.18c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M339.25,4347.94h1113.01c23.12,0,43.51,16.73,55.55,42.19l1.45,3.81H282.25l1.45-3.81c12.04-25.46,32.43-42.19,55.55-42.19Z"
  })), _text85 || (_text85 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(545.52 4518.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041A\u0430\u0444\u0435\u0434"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 209.45,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 250.12,
    y: 0
  }, "\u0430 \u0441\u043F\u043E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 414.15,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 453.72,
    y: 0
  }, "\u0442\u0438\u0432\u043D\u043E\u0439 "))), _text86 || (_text86 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(664.76 4606.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0434\u0435\u044F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 115.1,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 152.49,
    y: 0
  }, "\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438"))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1717.75,4041.87c0-39.45,31.98-71.43,71.43-71.43h1103.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1103.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1784.2,3969.94h1112.1c23.1,0,43.47,16.73,55.5,42.19l1.45,3.81h-1226l1.45-3.81c12.03-25.46,32.4-42.19,55.5-42.19Z"
  })), _text87 || (_text87 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2001.6 4175.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041A\u0430\u0444\u0435\u0434"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 209.45,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 250.12,
    y: 0
  }, "\u0430 \u0444\u0438\u043B\u043E\u043B\u043E\u0433\u0438\u0438"))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1717.75,4419.87c0-39.45,31.98-71.43,71.43-71.43h1103.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1103.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1784.2,4347.94h1112.1c23.1,0,43.47,16.73,55.5,42.19l1.45,3.81h-1226l1.45-3.81c12.03-25.46,32.4-42.19,55.5-42.19Z"
  })), _text88 || (_text88 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1964.62 4518.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041A\u0430\u0444\u0435\u0434"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 209.45,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 250.12,
    y: 0
  }, "\u0430 \u0438\u043D\u043E\u0441\u0442"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 496.14,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 536.81,
    y: 0
  }, "\u0430\u043D\u043D\u044B\u0445 "))), _text89 || (_text89 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2218.24 4606.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u044F\u0437\u044B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 126.79,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 165.57,
    y: 0
  }, "\u043E\u0432"))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3157.75,4041.87c0-39.45,31.98-71.43,71.43-71.43h1104.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1104.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3224.25,3969.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text90 || (_text90 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3395.35 4139.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041A\u0430\u0444\u0435\u0434"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 209.45,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 250.12,
    y: 0
  }, "\u0430 \u043C\u0430"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 386.6,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 423.99,
    y: 0
  }, "\u0435\u043C\u0430\u0442\u0438\u043A\u0438 \u0438 "))), _text91 || (_text91 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3465.16 4227.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0435\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 67.8,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 105.19,
    y: 0
  }, "\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u043D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 519.02,
    y: 0
  }, "\u0430"), /*#__PURE__*/React.createElement("tspan", {
    x: 553.2,
    y: 0
  }, "\u0443\u043A"))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3157.75,4419.87c0-39.45,31.98-71.43,71.43-71.43h1104.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1104.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3224.25,4347.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text92 || (_text92 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3327.5 4519.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041A\u0430\u0444\u0435\u0434"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 209.45,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 250.12,
    y: 0
  }, "\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 "))), _text93 || (_text93 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3585.77 4607.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 0,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 37.39,
    y: 0
  }, "\u0435"), /*#__PURE__*/React.createElement("tspan", {
    x: 72.11,
    y: 0
  }, "\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0439"))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1717.75,4796.87c0-39.45,31.98-71.43,71.43-71.43h1103.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1103.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1784.2,4724.94h1112.1c23.1,0,43.47,16.73,55.5,42.19l1.45,3.81h-1226l1.45-3.81c12.03-25.46,32.4-42.19,55.5-42.19Z"
  })), _text94 || (_text94 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1988.98 4910.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041A\u0430\u0444\u0435\u0434"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 209.45,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 250.12,
    y: 0
  }, "\u0430 \u0437\u0430"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 370.92,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 410.41,
    y: 0
  }, "\u0443\u0431\u0435\u0436\u043D\u043E\u0439 "))), _text95 || (_text95 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2153.18 4998.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0444\u0438\u043B\u043E\u043B\u043E\u0433\u0438\u0438"))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1717.75,5174.87c0-39.45,31.98-71.43,71.43-71.43h1103.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1103.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1784.2,5102.94h1112.1c23.1,0,43.47,16.73,55.5,42.19l1.45,3.81h-1226l1.45-3.81c12.03-25.46,32.4-42.19,55.5-42.19Z"
  })), _text96 || (_text96 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1999.6 5294.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041A\u0430\u0444\u0435\u0434"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 209.45,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 250.12,
    y: 0
  }, "\u0430 \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u043E"))), _text97 || (_text97 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2656.23 5294.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text98 || (_text98 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2019.28 5382.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u043F\u043E\u043B\u0438\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 527.75,
    y: 0
  }, "\u0430"), /*#__PURE__*/React.createElement("tspan", {
    x: 561.94,
    y: 0
  }, "\u0443\u043A"))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3157.75,4796.87c0-39.45,31.98-71.43,71.43-71.43h1104.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1104.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3224.25,4724.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text99 || (_text99 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3443.83 4930.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041A\u0430\u0444\u0435\u0434"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 209.45,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 250.12,
    y: 0
  }, "\u0430 \u044D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 336.16,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 374.94,
    y: 0
  }, "\u043E\u043D\u043E\u043C\u0438\u043A\u0438"))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3157.75,5174.87c0-39.45,31.98-71.43,71.43-71.43h1104.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1104.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3224.25,5102.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text100 || (_text100 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3291.69 5308.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041A\u0430\u0444\u0435\u0434"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 209.45,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 250.12,
    y: 0
  }, "\u0430 \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432 \u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0430"))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M6110.75,2069.79c0-61.5,49.85-111.35,111.35-111.35h1024.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1024.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6177.25,1957.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text101 || (_text101 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6312.57 2325.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 47.69,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 81.8,
    y: 0
  }, "\u0434\u0435\u043B "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 215.04,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 253.82,
    y: 0
  }, "\u043E\u043D\u0442\u0440\u043E\u043B\u044F \u043A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 587.28,
    y: 0
  }, "\u0430"), /*#__PURE__*/React.createElement("tspan", {
    x: 621.53,
    y: 0
  }, "\u0447\u0435\u0441\u0442\u0432\u0430 "))), _text102 || (_text102 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6519.58 2413.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u043E\u0431"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 78.24,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 118.91,
    y: 0
  }, "\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u044F"))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M6652.25,2058.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text103 || (_text103 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6699.67 2170.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text104 || (_text104 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6777.02 2170.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M6110.75,1427.79c0-61.5,49.85-111.35,111.35-111.35h1024.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1024.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6177.25,1315.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text105 || (_text105 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6342.17 1683.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 47.69,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 81.8,
    y: 0
  }, "\u0434\u0435\u043B \u043C\u0435"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 299.77,
    y: 0
  }, "\u0436"), /*#__PURE__*/React.createElement("tspan", {
    x: 353.06,
    y: 0
  }, "\u0434\u0443\u043D\u0430\u0440"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 549.82,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    x: 586.82,
    y: 0
  }, "\u0434\u043D\u043E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 709.29,
    y: 0
  }, "\u0433"), /*#__PURE__*/React.createElement("tspan", {
    x: 741.98,
    y: 0
  }, "\u043E "))), _text106 || (_text106 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6470.82 1771.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 32.19,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    x: 69.9,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 107.22,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 146.71,
    y: 0
  }, "\u0443"), /*#__PURE__*/React.createElement("tspan", {
    x: 179.54,
    y: 0
  }, "\u0434\u043D\u0438\u0447\u0435\u0441\u0442\u0432\u0430"))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M6652.25,1416.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text107 || (_text107 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6699.67 1528.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text108 || (_text108 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6777.02 1528.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M6110.75,2716.64c0-66.39,53.82-120.21,120.21-120.21h1006.58c66.39,0,120.21,53.82,120.21,120.21v397.59c0,66.39-53.82,120.2-120.21,120.2h-1006.58c-66.39,0-120.21-53.82-120.21-120.2v-397.59Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6177.25,2595.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.45,32.42-42.19,55.55-42.19Z"
  })), _text109 || (_text109 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6236.36 2963.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 47.69,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 81.8,
    y: 0
  }, "\u0434\u0435\u043B "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 215.04,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 255.71,
    y: 0
  }, "\u0430\u0431"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 330.85,
    y: 0
  }, "\u043E"), /*#__PURE__*/React.createElement("tspan", {
    x: 368.56,
    y: 0
  }, "\u0442\u044B \u0441 \u043E\u0431"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 603.07,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 643.74,
    y: 0
  }, "\u0430\u0449\u0435\u043D\u0438\u044F\u043C\u0438 "))), _text110 || (_text110 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6193.92 3051.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u0438 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043B\u0438\u0446, "))), _text111 || (_text111 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6219.95 3139.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0430"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 35.64,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 75.14,
    y: 0
  }, "\u0445\u0438\u0432, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 222.71,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 261.49,
    y: 0
  }, "\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u0438 \u043C\u043E\u043D\u0438"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 787.35,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 824.74,
    y: 0
  }, "\u043E\u0440\u0438\u043D\u0433"))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M6652.25,2696.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text112 || (_text112 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6699.67 2808.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text113 || (_text113 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6777.02 2808.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M6110.75,3392.79c0-61.5,49.85-111.35,111.35-111.35h1024.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1024.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6177.25,3280.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text114 || (_text114 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6508.63 3647.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u041E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 47.69,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 81.8,
    y: 0
  }, "\u0434\u0435\u043B \u043A\u0430\u0434\u0440\u043E\u0432"))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M6652.25,3381.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text115 || (_text115 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6699.67 3493.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), _text116 || (_text116 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6775.3 3493.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M6110.75,4008.24c0-42.97,34.83-77.8,77.8-77.8h1091.4c42.97,0,77.8,34.83,77.8,77.8v328.4c0,42.97-34.83,77.8-77.8,77.8h-1091.4c-42.97,0-77.8-34.83-77.8-77.8v-328.4Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6177.25,3929.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text117 || (_text117 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6256.94 4130.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u042E\u0440\u0438\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 183.07,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 221.85,
    y: 0
  }, "\u043E\u043D\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 335.77,
    y: 0
  }, "\u0443"), /*#__PURE__*/React.createElement("tspan", {
    x: 369.71,
    y: 0
  }, "\u043B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 410.52,
    y: 0
  }, "\u044C"), /*#__PURE__*/React.createElement("tspan", {
    x: 445.2,
    y: 0
  }, "\u0442 \u0438 \u0443\u043F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 635.9,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 676.57,
    y: 0
  }, "\u0430\u0432\u043B\u0435\u043D\u0438\u0435 "))), _text118 || (_text118 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6171.32 4218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0441\u0438\u0441"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 107.43,
    y: 0
  }, "\u0442"), /*#__PURE__*/React.createElement("tspan", {
    x: 144.82,
    y: 0
  }, "\u0435\u043C\u043E\u0439 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 327.43,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 366.21,
    y: 0
  }, "\u043E\u043C\u043F\u043B\u0430\u0435\u043D\u0441"))), _text119 || (_text119 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6856.53 4218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text120 || (_text120 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6881.17 4218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 0,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.78,
    y: 0
  }, "\u043E\u043D\u0442\u0440\u043E\u043B\u044F \u043F\u043E "))), _text121 || (_text121 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6384.7 4306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0431\u043E\u0440\u044C\u0431\u0435 \u0441 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 295.81,
    y: 0
  }, "\u043A"), /*#__PURE__*/React.createElement("tspan", {
    x: 334.6,
    y: 0
  }, "\u043E\u0440"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 413.94,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 453.43,
    y: 0
  }, "\u0443\u043F\u0446\u0438\u0435\u0439"))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M6110.75,4556.85c0-46.62,37.79-84.41,84.41-84.41h1078.18c46.62,0,84.41,37.79,84.41,84.41v172.18c0,46.62-37.79,84.41-84.41,84.41h-1078.18c-46.62,0-84.41-37.79-84.41-84.41v-172.18Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6177.25,4471.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text122 || (_text122 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6290.42 4642.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0421\u0435\u043A\u0440\u0435\u0442\u0430\u0440\u044C \u0441\u043E\u0432\u0435\u0442\u0430 \u0432\u044B\u0441\u0448\u0435"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 812.27,
    y: 0
  }, "\u0433"), /*#__PURE__*/React.createElement("tspan", {
    x: 844.95,
    y: 0
  }, "\u043E "))), _text123 || (_text123 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6519.59 4730.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u043E\u0431"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 78.24,
    y: 0
  }, "\u0440"), /*#__PURE__*/React.createElement("tspan", {
    x: 118.91,
    y: 0
  }, "\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u044F"))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2222.75,179.15h224.14v4.58h-224.14v-4.58ZM2222.75,195.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM2446.89,167.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3072.04,501.27v-141.84s-4.58,0-4.58,0v141.84s4.58,0,4.58,0ZM3056,501.27l13.75,13.75,13.75-13.75-13.75-13.75-13.75,13.75ZM3083.5,359.43l-13.75-13.75-13.75,13.75,13.75,13.75,13.75-13.75Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2222.75,723.15h224.14v4.58h-224.14v-4.58ZM2222.75,739.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM2446.89,711.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3693.75,727.73h234.13v-4.58h-234.13s0,4.58,0,4.58ZM3693.75,711.69l-13.75,13.75,13.75,13.75,13.75-13.75-13.75-13.75ZM3927.88,739.19l13.75-13.75-13.75-13.75-13.75,13.75,13.75,13.75Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3072.04,1072.58v-123.14s-4.58,0-4.58,0v123.14s4.58,0,4.58,0ZM3056,1072.58l13.75,13.75,13.75-13.75-13.75-13.75-13.75,13.75ZM3083.5,949.43l-13.75-13.75-13.75,13.75,13.75,13.75,13.75-13.75Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2333.04,1295.48v-224.04s-4.58,0-4.58,0v224.04s4.58,0,4.58,0ZM2317,1295.48l13.75,13.75,13.75-13.75-13.75-13.75-13.75,13.75ZM2344.5,1071.44l-13.75-13.75-13.75,13.75,13.75,13.75,13.75-13.75Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M13.75,1069.15l7583.3,6.05v4.58L13.75,1073.73v-4.58ZM13.74,1085.19l-13.74-13.76,13.76-13.74,13.74,13.76-13.76,13.74ZM7597.06,1063.74l13.74,13.76-13.76,13.74-13.74-13.76,13.76-13.74Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M888.46,1295.09v-222.65h4.58v222.65s-4.58,0-4.58,0ZM904.5,1295.09l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75ZM877,1072.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3771.46,1295.88v-219.44h4.58v219.44h-4.58ZM3787.5,1295.88l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75ZM3760,1076.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M5241.46,1295.72v-219.28h4.58v219.28h-4.58ZM5257.5,1295.72l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75ZM5230,1076.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M7599.04,4643.06V1076.44s-4.58,0-4.58,0v3566.62s4.58,0,4.58,0ZM7583,4643.06l13.75,13.75,13.75-13.75-13.75-13.75-13.75,13.75ZM7610.5,1076.44l-13.75-13.75-13.75,13.75,13.75,13.75,13.75-13.75Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M4535.75,1547.15h71.91v4.58h-71.91v-4.58ZM4535.75,1563.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM4607.66,1535.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M4538.04,1549.44v2503.78h-4.58V1549.44h4.58ZM4522,1549.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM4549.5,4053.22l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M4537.75,2140.15h83.17v4.58h-83.17v-4.58ZM4537.75,2156.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM4620.92,2128.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M4536.75,2789.15h84.05v4.58h-84.05v-4.58ZM4536.75,2805.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM4620.8,2777.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M4536.75,3424.15h84.05v4.58h-84.05v-4.58ZM4536.75,3440.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM4620.8,3412.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M4536.75,4050.15h84.05v4.58h-84.05v-4.58ZM4536.75,4066.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM4620.8,4038.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3069.75,1547.15l87.33.16v4.58s-87.33-.16-87.33-.16v-4.58ZM3069.72,1563.19l-13.72-13.78,13.78-13.72,13.72,13.78-13.78,13.72ZM3157.1,1535.85l13.72,13.77-13.77,13.73-13.73-13.78,13.78-13.72Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3072.04,1548.44v1352.51h-4.58v-1352.51h4.58ZM3056,1548.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM3083.5,2900.95l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3072.8,2280.4l86.12,44.43-2.1,4.07-86.12-44.43,2.1-4.07ZM3065.45,2294.66l-5.92-18.52,18.52-5.92,5.92,18.52-18.52,5.92ZM3164.17,2314.65l5.92,18.52-18.53,5.91-5.91-18.52,18.52-5.92Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3070.75,2899.15h86.72v4.58h-86.72v-4.58ZM3070.75,2915.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3157.47,2887.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1622.75,1547.15h84.72v4.58h-84.72v-4.58ZM1622.75,1563.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1707.47,1535.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1620.46,1548.44v1242.37s4.58,0,4.58,0v-1242.37s-4.58,0-4.58,0ZM1636.5,1548.44l-13.75-13.75-13.75,13.75,13.75,13.75,13.75-13.75ZM1609,2790.81l13.75,13.75,13.75-13.75-13.75-13.75-13.75,13.75Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1627.75,2150.15h79.62v4.58h-79.62v-4.58ZM1627.75,2166.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1707.37,2138.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1622.75,2789.15h84.72v4.58h-84.72v-4.58ZM1622.75,2805.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1707.47,2777.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M189.75,1547.15h83.12v4.58h-83.12v-4.58ZM189.75,1563.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM272.88,1535.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M187.46,1548.44v1324.26s4.58,0,4.58,0v-1324.26s-4.58,0-4.58,0ZM203.5,1548.44l-13.75-13.75-13.75,13.75,13.75,13.75,13.75-13.75ZM176,2872.7l13.75,13.75,13.75-13.75-13.75-13.75-13.75,13.75Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M189.75,2222.15h83.12v4.58h-83.12v-4.58ZM189.75,2238.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM272.88,2210.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M189.75,2864.15h83.12v4.58h-83.12v-4.58ZM189.75,2880.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM272.88,2852.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M19.04,1071.44v2249.72h-4.58V1071.44h4.58ZM3,1071.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM30.5,3321.15l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M16.75,3318.15h3772.18v4.58H16.75v-4.58ZM16.75,3334.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3788.93,3306.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M189.75,3674.15h83.12v4.58h-83.12v-4.58ZM189.75,3690.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM272.88,3662.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M194.04,3676.44v854.95h-4.58v-854.95s4.58,0,4.58,0ZM178,3676.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM205.5,4531.39l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M189.75,4149.15h83.12v4.58h-83.12v-4.58ZM189.75,4165.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM272.88,4137.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M189.75,4529.15h83.12v4.58h-83.12v-4.58ZM189.75,4545.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM272.88,4517.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M896.04,3320.44v105.8h-4.58v-105.8s4.58,0,4.58,0ZM880,3320.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM907.5,3426.23l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2335.04,3320.44v105.8h-4.58v-105.8h4.58ZM2319,3320.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM2346.5,3426.23l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3791.04,3320.44v105.8h-4.58v-105.8h4.58ZM3775,3320.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM3802.5,3426.23l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1632.75,3674.15h83.12v4.58h-83.12v-4.58ZM1632.75,3690.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1715.88,3662.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1632.07,3676.44l-1.61,1589.29h4.58l1.61-1589.29h-4.58ZM1648.11,3676.45l-13.74-13.76-13.76,13.74,13.74,13.76,13.76-13.74ZM1619,5265.72l13.74,13.76,13.76-13.74-13.74-13.76-13.76,13.74Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1632.75,4149.15h83.12v4.58h-83.12v-4.58ZM1632.75,4165.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1715.88,4137.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1632.75,4525.15h83.12v4.58h-83.12v-4.58ZM1632.75,4541.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1715.88,4513.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1632.75,5263.15h83.12v4.58h-83.12v-4.58ZM1632.75,5279.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1715.88,5251.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1632.75,4905.15h83.12v4.58h-83.12v-4.58ZM1632.75,4921.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1715.88,4893.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3072.75,3674.15h83.12v4.58h-83.12v-4.58ZM3072.75,3690.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3155.87,3662.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3072.07,3676.44l-1.61,1589.29h4.58l1.61-1589.29h-4.58ZM3088.11,3676.45l-13.74-13.76-13.76,13.74,13.74,13.76,13.76-13.74ZM3059,5265.72l13.74,13.76,13.76-13.74-13.74-13.76-13.76,13.74Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3072.75,4149.15h83.12v4.58h-83.12v-4.58ZM3072.75,4165.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3155.87,4137.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3072.75,4525.15h83.12v4.58h-83.12v-4.58ZM3072.75,4541.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3155.87,4513.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3072.75,5263.15h83.12v4.58h-83.12v-4.58ZM3072.75,5279.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3155.87,5251.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M3072.75,4905.15h83.12v4.58h-83.12v-4.58ZM3072.75,4921.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3155.87,4893.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M7357.75,1610.15h239.28v4.58h-239.28v-4.58ZM7357.75,1626.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM7597.03,1598.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M7357.75,2263.15h239.28v4.58h-239.28v-4.58ZM7357.75,2279.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM7597.03,2251.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M7357.75,2936.15h239.28v4.58h-239.28v-4.58ZM7357.75,2952.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM7597.03,2924.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M7357.75,3575.15h239.28v4.58h-239.28v-4.58ZM7357.75,3591.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM7597.03,3563.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M7357.75,4164.15h239.28v4.58h-239.28v-4.58ZM7357.75,4180.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM7597.03,4152.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M7357.75,4640.15h239.28v4.58h-239.28v-4.58ZM7357.75,4656.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM7597.03,4628.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructuRu);
export default __webpack_public_path__ + "static/media/structu_ru.9a7c774c4517b5e0159163bb7d4c219d.svg";
export { ForwardRef as ReactComponent };